import { render, staticRenderFns } from "./GoodsSpecValueForm.vue?vue&type=template&id=bb5ace42&scoped=true"
import script from "./GoodsSpecValueForm.vue?vue&type=script&lang=ts"
export * from "./GoodsSpecValueForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodsSpecValueForm.vue?vue&type=style&index=0&id=bb5ace42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ace42",
  null
  
)

export default component.exports